import React, { useState } from "react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-screen-md mx-auto p-6 bg-white shadow rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {/* Question 1 */}
        <div className="border border-gray-200 rounded-lg">
          <h3>
            <button
              type="button"
              className="flex justify-between items-center w-full p-4 font-medium text-gray-900 text-left bg-gray-100 rounded-t-lg hover:bg-gray-200"
              onClick={() => toggleFAQ(1)}
            >
              <span>What is PressRequest.io?</span>
              <svg
                className={`w-4 h-4 shrink-0 transform transition-transform ${
                  openIndex === 1 ? "rotate-45" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </h3>
          {openIndex === 1 && (
            <div className="p-4 text-gray-700">
              PressRequest.io connects experts with journalists working on relevant stories. It aggregates leads from
              platforms like Qwoted, Featured, HelpAB2BWriter, and more, offering a one-stop solution for PR professionals.
            </div>
          )}
        </div>

        {/* Question 2 */}
        <div className="border border-gray-200 rounded-lg">
          <h3>
            <button
              type="button"
              className="flex justify-between items-center w-full p-4 font-medium text-gray-900 text-left bg-gray-100 rounded-t-lg hover:bg-gray-200"
              onClick={() => toggleFAQ(2)}
            >
              <span>How is PressRequest.io different from HARO?</span>
              <svg
                className={`w-4 h-4 shrink-0 transform transition-transform ${
                  openIndex === 2 ? "rotate-45" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </h3>
          {openIndex === 2 && (
            <div className="p-4 text-gray-700">
              HARO has been shut down by Cision. PressRequest.io is a modern alternative that leverages AI to recommend
              the most relevant leads and provides an easier way to connect with journalists in need of expert commentary.
            </div>
          )}
        </div>

        {/* Question 3 */}
        <div className="border border-gray-200 rounded-lg">
          <h3>
            <button
              type="button"
              className="flex justify-between items-center w-full p-4 font-medium text-gray-900 text-left bg-gray-100 rounded-t-lg hover:bg-gray-200"
              onClick={() => toggleFAQ(3)}
            >
              <span>How do I know which leads are a good fit for me?</span>
              <svg
                className={`w-4 h-4 shrink-0 transform transition-transform ${
                  openIndex === 3 ? "rotate-45" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </h3>
          {openIndex === 3 && (
            <div className="p-4 text-gray-700">
              PressRequest.io uses AI to analyze your expertise and match you with leads that align with your professional
              background. This saves time and increases the likelihood of getting featured.
            </div>
          )}
        </div>

        {/* New Question 1 */}
        <div className="border border-gray-200 rounded-lg">
          <h3>
            <button
              type="button"
              className="flex justify-between items-center w-full p-4 font-medium text-gray-900 text-left bg-gray-100 rounded-t-lg hover:bg-gray-200"
              onClick={() => toggleFAQ(4)}
            >
              <span>How is PressRequest.io different from other platforms?</span>
              <svg
                className={`w-4 h-4 shrink-0 transform transition-transform ${
                  openIndex === 4 ? "rotate-45" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </h3>
          {openIndex === 4 && (
            <div className="p-4 text-gray-700">
              PressRequest.io was built by a former journalist who understands the challenges of sourcing expert
              commentary on tight deadlines. It is designed with both PR professionals and journalists in mind, ensuring
              efficiency for both sides.
            </div>
          )}
        </div>

        {/* New Question 2 */}
        <div className="border border-gray-200 rounded-lg">
          <h3>
            <button
              type="button"
              className="flex justify-between items-center w-full p-4 font-medium text-gray-900 text-left bg-gray-100 rounded-t-lg hover:bg-gray-200"
              onClick={() => toggleFAQ(5)}
            >
              <span>What is the ROI of using PressRequest.io?</span>
              <svg
                className={`w-4 h-4 shrink-0 transform transition-transform ${
                  openIndex === 5 ? "rotate-45" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </h3>
          {openIndex === 5 && (
            <div className="p-4 text-gray-700">
              The ROI of PressRequest.io lies in its ability to secure authentic press mentions. These mentions not only
              enhance your brand's visibility but also signal to Google and AI-driven tools that you are a trusted expert
              in your field, improving your overall credibility and SEO.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
